var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTripArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 95,
    viewBox: "0 0 10 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L5 88",
    stroke: "#44585F",
    strokeWidth: 0.228645,
    strokeDasharray: "1.14 1.14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57291,
    cy: 89.5729,
    r: 4.57291,
    fill: "#33C154",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57324,
    cy: 89.5729,
    r: 3.42968,
    fill: "#33C154"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57291,
    cy: 4.57291,
    r: 4.57291,
    fill: "#E57556",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57324,
    cy: 4.5729,
    r: 3.42968,
    fill: "#E57556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripArrow);
export default __webpack_public_path__ + "static/media/trip_arrow.50e7d0ce5bcf1798fdf2eeceebd2d23f.svg";
export { ForwardRef as ReactComponent };